export const deleteCategory = payload => ({
    type: "DELETE_CATEGORY",
    payload
})